import '../../boot'
import './index.scss'
import { createApp } from 'vue/dist/vue.esm-bundler'
import { NForm, NCard, NSpace, NFormItem, NInputNumber, NSelect, NDataTable } from 'naive-ui'
import helper from "@/helper";
import AppLayoutMixin from "@/app-layout-mixin";
import EmbedCode from "@/components/embed";

createApp({
    components: { NForm, NCard, NSpace, NFormItem, NInputNumber, NSelect, NDataTable, EmbedCode },
    mixins: [ AppLayoutMixin ],
    data() {
        return {
            unit: 'm',
            a: 70,
            b: 100,
            height: 60,
            units: helper.lengthUnitsGrouped,
            tableColumns: [
                {
                    title: 'Unit',
                    key: 'unit'
                },
                {
                    title: 'Result',
                    key: 'result'
                }
            ]
        }
    },
    computed: {

        result() {
            return (this.a + this.b) * this.height * 0.5;
        },

        resultTable() {
            const data = [];

            for (let unit in helper.conv.length) {
                data.push({
                    unit: unit + '²',
                    result: (this.result * Math.pow(helper.conv.length[this.unit], 2)) / Math.pow(helper.conv.length[unit], 2)
                });
            }

            return data;
        },

    }
}).mount('#app')
